var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, InputBase, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { salesOrderSearchText } from "../../services/behaviorSubjectService";
import { Cancel, Search } from "@mui/icons-material";
import { useDeviceQueries } from "../../shared/Utilites";
var SearchBar = function (_a) {
    var orderStatus = _a.orderStatus, _b = _a.preserveSearchOnTabChange, preserveSearchOnTabChange = _b === void 0 ? false : _b, value = _a.value, onValueChange = _a.onValueChange, onSearchSubmit = _a.onSearchSubmit;
    var t = useTranslation().t;
    var _c = useState(""), searchBarText = _c[0], setSearchBarText = _c[1];
    var isMobile = useDeviceQueries();
    var isControlled = onValueChange != null;
    var displayValue = isControlled ? (value !== null && value !== void 0 ? value : "") : searchBarText;
    useEffect(function () {
        if (preserveSearchOnTabChange || isControlled) {
            return;
        }
        setSearchBarText("");
        salesOrderSearchText.next({
            searchText: "",
            orderTab: orderStatus,
        });
    }, [orderStatus, preserveSearchOnTabChange, isControlled]);
    var emitSearch = function (text) {
        /** Trim only; URL encoding happens in `appendStReportsSalesOrderDetailsQuerySegment`. */
        var normalized = text.trim();
        if (isControlled) {
            onValueChange(normalized);
            return;
        }
        setSearchBarText(normalized);
        salesOrderSearchText.next({
            searchText: normalized,
            orderTab: orderStatus,
        });
    };
    var makeFieldsEmpty = function () {
        emitSearch("");
    };
    var handleSearchClick = function () {
        if (displayValue.trim()) {
            onSearchSubmit === null || onSearchSubmit === void 0 ? void 0 : onSearchSubmit();
        }
    };
    return (_jsxs(Paper, __assign({ className: "SO_SearchBox ST_CommonBorderRadius", sx: { width: isMobile ? "100%" : "25%", marginBottom: isMobile ? "10px" : "" } }, { children: [_jsx(InputBase, { autoFocus: true, value: displayValue, onChange: function (e) { return emitSearch(e.target.value); }, onKeyDown: function (e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onSearchSubmit === null || onSearchSubmit === void 0 ? void 0 : onSearchSubmit();
                    }
                }, sx: { ml: 2, flex: 1 }, size: "small", placeholder: t("myCustomers_radioButton1"), inputProps: { "aria-label": "searchProducts", className: "ST_CommonTextFont_size" }, className: "ST_CommonTextFont_size" }), _jsx(IconButton, __assign({ type: "button", sx: { p: "10px" }, "aria-label": "search", onClick: handleSearchClick }, { children: _jsx(Search, {}) })), displayValue ? (_jsx(IconButton, __assign({ type: "button", sx: { p: "10px" }, "aria-label": "clear search", onClick: makeFieldsEmpty }, { children: _jsx(Cancel, {}) }))) : null] })));
};
export default SearchBar;
